/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadStagingDto } from '../../models/lexplus-upload-staging-dto';

export interface UploadsControllerUploadDateiV1$Params {
  
    /**
     * The file to upload.
     */
    body: {
'file': Blob;
}
}

export function uploadsControllerUploadDateiV1(http: HttpClient, rootUrl: string, params: UploadsControllerUploadDateiV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusUploadStagingDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerUploadDateiV1.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusUploadStagingDto>;
    })
  );
}

uploadsControllerUploadDateiV1.PATH = '/v1/uploads/datei';
